import { z } from 'zod';

import type { EndpointContractGroup } from '../schemaUtils';

/**
 * Schema definition for all auth endpoints
 */
export const authApiSchemas = {
  register: {
    resend: {
      path: '/chats/auth/register/resend',
      method: 'POST',
      schema: {
        body: z.object({
          email: z.string().email(),
        }),
        response: {
          200: z.void(),
        },
      },
    },
  },
  iframe: {
    compatibilityCheck: {
      path: '/iframe/compatibility-check',
      method: 'POST',
      schema: {
        body: z.object({
          url: z.string().url(),
        }),
        response: {
          200: z.object({
            url: z.string(),
            isEmbeddable: z.boolean(),
            reason: z.string().nullable(),
            headers: z.object({
              xFrameOptions: z.string().nullable(),
              contentSecurityPolicy: z.string().nullable(),
            }),
          }),
        },
      },
    },
  },
} satisfies EndpointContractGroup;
